<template>
  <div class="ai-welcome-message">
    <div class="message-header">
      <span class="sender-label">AI Assistant:</span>
    </div>
    <div class="message-content">
      <div class="message-bubble-wrapper">
        <div class="message-tail"></div>
        <div class="message-bubble">
          <p class="message-text">
            Hi, how can I help you with this form? You can also start from choosing one of the purposes of the form from below:
          </p>
        </div>
      </div>
    </div>
    <div v-if="!hideQuickOptions" class="quick-options">
      <!-- Original:
      <button 
        v-for="option in quickOptions" 
        :key="option.text"
        class="quick-option-button"
        @click="handleOptionClick(option.text)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path v-if="option.icon === 'intake'" d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="#1E4670"/>
          <path v-else-if="option.icon === 'consent'" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17zM19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-2 10H7v-2h10v2z" fill="#1E4670"/>
          <path v-else-if="option.icon === 'followup'" d="M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79 2.73 2.71 7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58 3.51-3.47 9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z" fill="#1E4670"/>
          <path v-else d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z" fill="#1E4670"/>
        </svg>
        <span>{{ option.text }}</span>
      </button>
      -->
      <ResponsiveButton
        v-for="option in quickOptions"
        :key="option.text"
        :display_name="option.text"
        button_type="outlined"
        built_in_theme="dark"
        size="small"
        @click-button="handleOptionClick(option.text)"
        button_border_radius="100px"
      >
        <template #prefix>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path v-if="option.icon === 'intake'" d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="#1E4670"/>
            <path v-else-if="option.icon === 'consent'" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17zM19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-2 10H7v-2h10v2z" fill="#1E4670"/>
            <path v-else-if="option.icon === 'followup'" d="M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79 2.73 2.71 7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58 3.51-3.47 9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z" fill="#1E4670"/>
            <path v-else d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z" fill="#1E4670"/>
          </svg>
        </template>
      </ResponsiveButton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIWelcomeMessage',
  props: {
    show: {
      type: Boolean,
      default: true
    },
    hideQuickOptions: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      quickOptions: [
        { text: 'Intake', icon: 'intake' },
        { text: 'Consent', icon: 'consent' },
        { text: 'Follow-up / Update', icon: 'followup' },
        { text: 'Custom', icon: 'custom' }
      ]
    };
  },
  emits: ['quick-option-selected'],
  methods: {
    handleOptionClick(text) {
      this.$emit('quick-option-selected', { text });
    }
  }
};
</script>

<style scoped>
.ai-welcome-message {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.message-header {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 0 32px;
}

.sender-label {
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 700;
  line-height: 12px;
  letter-spacing: 0.25px;
  color: #666;
}

.message-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 32px;
}

.message-bubble-wrapper {
  display: flex;
  align-items: center;
  padding-right: 6px;
  width: 100%;
}

.message-tail {
  width: 20.114px;
  height: 21.528px;
  margin-right: -6px;
  position: relative;
}

.message-tail::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(15deg);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 18px solid #E4F3F5;
}

.message-bubble {
  flex: 1;
  background: #E4F3F5;
  border-radius: 20px;
  padding: 12px 24px;
  margin-right: -6px;
  margin-left: -2px;
}

.message-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #666;
  text-align: justify;
  margin: 0;
}

.quick-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 56px;
}

.quick-option-button {
  width: fit-content;
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 4px 16px;
  background: #FFFFFF;
  border: 1px solid #1E4670;
  border-radius: 100px;
  box-shadow: 0px 1px 3px 0px rgba(74, 74, 74, 0.25);
  cursor: pointer;
  transition: all 0.2s ease;
}

.quick-option-button:hover {
  background: rgba(30, 70, 112, 0.04);
}

.quick-option-button:active {
  background: rgba(30, 70, 112, 0.08);
}

.quick-option-button svg {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.quick-option-button span {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #1E4670;
  text-align: center;
  white-space: nowrap;
}
</style>
